
import React from 'react';
import { Button } from '@/components/ui/button';
import { CardTitle, CardDescription } from '@/components/ui/card';
import { Edit, Save, X } from 'lucide-react';

interface SystemConfigHeaderProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const SystemConfigHeader: React.FC<SystemConfigHeaderProps> = ({
  editing,
  onEditToggle,
  onSave
}) => {
  return (
    <div className="flex flex-row items-center justify-between space-y-0 pb-2">
      <div>
        <CardTitle>System Configuration</CardTitle>
        <CardDescription>Configure system-wide settings and alerts</CardDescription>
      </div>
      <div className="flex space-x-2">
        {editing ? (
          <>
            <Button 
              variant="outline" 
              size="sm" 
              onClick={onSave}
              className="flex items-center gap-1"
            >
              <Save className="h-4 w-4" />
              Save
            </Button>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={onEditToggle}
              className="flex items-center gap-1"
            >
              <X className="h-4 w-4" />
              Cancel
            </Button>
          </>
        ) : (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onEditToggle}
            className="flex items-center gap-1"
          >
            <Edit className="h-4 w-4" />
            Edit
          </Button>
        )}
      </div>
    </div>
  );
};

export default SystemConfigHeader;
